export default ({ components }) => {
  const { height, background } = components.header;
  const { height: curtainHeight, maxWidth } = components.curtain;

  return {
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      position: 'fixed',
      top: curtainHeight,
      left: 0,
      right: 0,
      height,
      background,
      boxShadow: [0, 2, 23, 0, 'rgba(204, 204, 204, 0.5)'],
      zIndex: 90,
      '@media (max-width: 799px)': {
        display: () => 'none',
      },
    },
    container: {
      display: 'flex',
      top: curtainHeight,
      height,
      maxWidth,
      zIndex: 90,
      '@media (max-width: 799px)': {
        display: () => 'none',
      },
    },
  };
};
